$( document ).ready(function() {
    initCart();
    //loadCart();
    initUpdateQuantityOnCartPage();
    $('.select-multiple-option').on('click', function(){
        setTimeout(function (){initSelectMultipleVariant();},100);
    });
});

function initSelectMultipleVariant() {
    let options = [];
    let counter = 0;
    $('.multiple-option').each(function(){
        options[counter] = $(this).find('input[type="radio"]:checked').val();
        counter++;
    });

    let available = true;
    $('#pdp-multiple-variants-list option').each(function(){
        if(($(this).data('option1') == options[0] && $(this).data('option2') == options[1]) || ($(this).data('option1') == options[0] && $(this).data('option2') == null) || ($(this).data('option1') == options[0] && $(this).data('option2') == '')){
            available = $(this).data('available');
            $('input[name="id"]').val($(this).val());
        }
    });

    if(available == false) {
        $('#notify-when-available').show();
        $('#addToCartBtn').hide();
        $('#soldOutToCartBtn').show();
        $('#addToCartExtraBtn').hide();
        $('#productQuantitySelector').hide();
    }else{
        $('#notify-when-available').hide();
        $('#addToCartBtn').show();
        $('#soldOutToCartBtn').hide();
        $('#addToCartExtraBtn').show();
        $('#productQuantitySelector').show();
    }
}

function updateCurrencyIcon(price) {
    let activate_currency = 0;
    let money_format = '$';
    if(Shopify.currency.rate != 1.0) {
        activate_currency = 1;
        money_format = theme.settings.moneyFormat;
        price = price.toFixed(2);
        price = money_format.replace('{{amount}}', price);
    }else{
        price = money_format + price.toFixed(2);
    }
    return price;
}

function calculatePriceByCurrency(price) {
    if(Shopify.currency.rate != 1.0) {
        price = price * Shopify.currency.rate;
    }
    return price;
}

function loadCart() {
    jQuery.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: function(data) {

            var item_count = data['item_count'];
            var total_price = data['total_price']/100;
            var cart_has_subscibe_product = 0;

            var total_price_text = updateCurrencyIcon(total_price);

            $('#small_cart_subtotal').text(total_price_text);
            $('#total_price_checkout_button').text(total_price_text);

            //If there are items in cart
            if ( item_count > 0 ) {

                var cart_list = [];

                for( var i = 0; i < item_count; i++ ){
                    if(data['items'][i]) {
                        if (data['items'][i]['id']) {

                            var item_id = data['items'][i]['id'];
                            var product_title = data['items'][i]['title'];
                            var product_handle = data['items'][i]['handle'];
                            var quantity = data['items'][i]['quantity'];
                            var line_price = data['items'][i]['price'] / 100;
                            var product_url = data['items'][i]['url'];
                            var image_url = data['items'][i]['image'];
                            var variants = data['items'][i]['variant_options'];
                            var product_oz = Math.ceil(data['items'][i]['grams']/28.34952);
                            var preorder_icon = '';

                            var options = [];
                            for (var o = 0; o < variants.length; o++) {
                                var selected = data['items'][i]['variant_options'][o];
                                if (selected !== 'Default Title') {
                                    options.push(selected + '<br>');
                                }
                            }
                            var selected_options = options.join('');
                            var min_quantity = 1;

                            var product_price = updateCurrencyIcon(line_price);

                            product_title = product_title.replace('"PRE-ORDER"', "");

                            if(data['items'][i].properties != '' && data['items'][i].properties.preorder == 1){
                                preorder_icon = `<div class="uppercase bg-FFE800 text-sm text-red-menu font-helvetica inline-block font-bold rounded mb-2 px-2 pt-1.5" style="padding-bottom: 3px">` + preorderText + `</div>`;
                            }

                            var html = `<div class="flex justify-between border-t last:border-b border-EAEAEA py-4">
                                            <a href="${product_url}" class="w-140">
                                                <img src="${image_url}" class="w-full block" />
                                            </a>
                        
                                            <div class="w-cart-item">
                                                ${preorder_icon}
                                            
                                                <a href="${product_url}" class="font-helvetica font-medium text-lg leading-18 block text-231F20">${product_title}</a>
                        
                                                <div class="font-helvetica text-231F20 pt-2">${product_price}</div>
                        
                                                <div class="flex justify-between items-center pt-4">
                                                    <div class="grid grid-cols-3 border border-E0E0E0 items-center justify-center py-2 mt-1 rounded h-51 w-36 change_product_count" data-min-quantity="${min_quantity}"  data-variant="${data['items'][i]['variant_id']}">
                                                        <a href="javascript:void(0)" class="block justify-center grid cart__qty-minus cart-button-quantity-change icon-minus">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <path d="M5 12H19" stroke="#1F1D1D" stroke-linecap="square" stroke-linejoin="round"/>
                                                            </svg>
                                                        </a>
                                                            <input disabled id="product_quantity_${data['items'][i]['variant_id']}" type="number" value="${quantity}" class="quantity cart__qty-input text-center font-helvetica text-base pt-1.5 bg-transparent" />
                                                        <a href="javascript:void(0)" class="block justify-center grid cart__qty-plus cart-button-quantity-change icon-plus">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                 <path d="M12 5V19M5 12H19" stroke="#1F1D1D" stroke-linecap="square" stroke-linejoin="round"/>
                                                            </svg>
                                                        </a>
                                                    </div>
                                                    <a class="remove-item-from-cart" href="javascript:void(0)" data-productId="${item_id}">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <g clip-path="url(#clip0_425_69725)">
                                                                <path d="M2.5 5.00006H4.16667H17.5" stroke="#919191" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M15.8337 5.00008V16.6667C15.8337 17.1088 15.6581 17.5327 15.3455 17.8453C15.0329 18.1578 14.609 18.3334 14.167 18.3334H5.83366C5.39163 18.3334 4.96771 18.1578 4.65515 17.8453C4.34259 17.5327 4.16699 17.1088 4.16699 16.6667V5.00008M6.66699 5.00008V3.33341C6.66699 2.89139 6.84259 2.46746 7.15515 2.1549C7.46771 1.84234 7.89163 1.66675 8.33366 1.66675H11.667C12.109 1.66675 12.5329 1.84234 12.8455 2.1549C13.1581 2.46746 13.3337 2.89139 13.3337 3.33341V5.00008" stroke="#919191" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M8.33301 9.16675V14.1667" stroke="#919191" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                <path d="M11.667 9.16675V14.1667" stroke="#919191" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_425_69725">
                                                                    <rect width="20" height="20" fill="white"/>
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>`;

                            cart_list.push(html);
                        } //endif
                    }
                } // endfor

                jQuery('.mini-products-list').html( cart_list.join('') );

                initRedLineInCart(total_price);

                jQuery('.remove-item-from-cart').on('click',function(){
                    var product_variant_id = $(this).attr('data-productId');
                    $(this).parent().parent().parent().remove();
                    removeItemCountInCart(product_variant_id,0);
                });

                jQuery('.change_product_count .cart-button-quantity-change').on('click', function(){
                    var product_variant_id = $(this).closest('.change_product_count').attr('data-variant');
                    var current_element_quantity = parseInt($('#product_quantity_' + product_variant_id).val());
                    var current_element_properties = $(this).closest('.change_product_count').attr('data-properties');
                    var current_element_min_quantity = $(this).closest('.change_product_count').attr('data-min-quantity');

                    if($(this).hasClass('icon-plus')) {
                        var subscribe_item = $(this).data('subscribe_item');
                        var new_element_quantity = current_element_quantity + 1;
                        updateItemCountInCart(product_variant_id, new_element_quantity, current_element_properties, subscribe_item);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }else{
                        var new_element_quantity = current_element_quantity - 1;
                        removeItemCountInCart(product_variant_id,new_element_quantity);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }
                });
            }
        }
    });
}

function updateQuantityOnFixed(action) {
    let quantity= $('#pdp_quantity_fixed').val();
    if(action == 'plus') {
        quantity = parseInt(quantity) + 1;
    }
    if(action == 'minus') {
        if(quantity > 1) {
            quantity = parseInt(quantity) - 1;
        }
    }
    if(quantity > 0) {
        $('#pdp_quantity_fixed').val(quantity);
    }
}

function initCart() {
    $('#small_cart_pre_order_alert').hide();
    jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(data) {
            var cart_has_preorder_items = 0;
            var item_counts_in_cart = data.items.length;
            var total_items_in_cart = data.item_count;

            if(total_items_in_cart == 1){
                total_items_in_cart = total_items_in_cart + ' item';
            }else{
                total_items_in_cart = total_items_in_cart + ' items';
            }
            $('#small_cart_total_items').text(total_items_in_cart);

            if (item_counts_in_cart !== 0) {
                $('.header-cart-total-items').show();
                $('.header-cart-total-items').text(data.item_count);
            } else {
                $('.header-cart-total-items').hide();
            }

            data.items.forEach((item) => {
                if(item.properties != '' && item.properties.preorder == 1){
                    cart_has_preorder_items = 1;
                }
            });

            if(item_counts_in_cart>0) {
               // $('#not_empty_small_cart').show();
              //  $('#empty_small_cart').hide();
            }else{
              //  $('#not_empty_small_cart').hide();
            //    $('#empty_small_cart').show();
            }

            if(cart_has_preorder_items == 1) {
              //  $('#small_cart_pre_order_alert').show();
            }

        }
    });
}

function initRedLineInCart(cart_total_price) {
    var freeShippingPrice = calculatePriceByCurrency(freeShipping);
    var range = freeShippingPrice - cart_total_price;
    if(freeShippingPrice > cart_total_price) {
        var addText = freeShippingText1.replace('[range]', updateCurrencyIcon(range));
        $('#free_shipping_bar .free-shipping-desc').text(addText);

        var percent = freeShippingPrice/100;
        percent = 100 - Math.ceil(range/percent);
        $('#free_shipping_bar .free-shipping-progress').css('width', percent + '%');
        $('#calc_shipping_price').text('Next step');
    }else{
        $('#free_shipping_bar .free-shipping-desc').text(freeShippingText2);
        $('#free_shipping_bar .free-shipping-progress').css('width', '100%');
        $('#calc_shipping_price').text('Free');
    }
}

function removeItemCountInCart(variant_id,new_count, reload) {

    var data = {
        'id': variant_id,
        'quantity': new_count
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(data) {
            initCart();
            loadCart();
            if(reload == 1 || document.location.pathname=='/cart'){
                document.location.reload();
            }
        },
        error: function(error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            initCart();
            loadCart();
        }

    });
}

function updateProductQuantity(type) {
    let current_quantity = parseInt($('#pdp_quantity').val());
    let new_quantity = current_quantity;
    if(type == 'plus') {
        new_quantity = current_quantity + 1;
    }
    if(type == 'minus') {
        if(current_quantity > 1) {
            new_quantity = current_quantity - 1;
        }
    }
    $('#pdp_quantity').val(new_quantity);
}

function initUpdateQuantityOnCartPage(){
    $('.cart-quantity-update').on('click', function(){

        var product_id = $(this).data('product-id');
        var variant_id = $(this).data('variant-id');

        var current_element_quantity = parseInt($('#product_selected_quantity_' + product_id).val());

        if($(this).hasClass('icon-plus')) {
            updateItemCountInCart(variant_id, current_element_quantity, '', '', 1);
        }else{
            updateItemCountInCart(variant_id, current_element_quantity, '', '', 1);
        }

    });
}

function updateItemCountInCart(variant_id,new_count, properties, subscribe_item, reload) {

        var data = {
            "id": variant_id,
            "quantity": new_count
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function(data) {
                //initCart();
                //loadCart();
                if(reload == 1 || document.location.pathname=='/cart'){
                    document.location.reload();
                }
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
                //initCart();
                //loadCart();
            }
        });

}

function openSmallCart() {
   // $('body').css('overflow', 'hidden');
   // $('.small-cart-overlay').fadeIn(300);
   // let right = $('.small-cart-block').offset().right;
   // $(".small-cart-block").css({right:right}).animate({"right":"0px"}, "slow");
    window.monster_refresh();
    openCart();
}

function closeSmallCart() {
  //  $('body').css('overflow', 'auto');
  //  $('.small-cart-overlay').fadeOut(300);
  //  let right = $('.small-cart-block').offset().right;
   // $(".small-cart-block").css({right:right}).animate({"right":"-100%"}, "slow");
}

function quickAddItemToCartWithQuantity(variant_id, preorder) {
    let data = {
        "id": variant_id,
        "quantity": $('#pdp_quantity_fixed').val()
    }

    if(preorder == 1) {
        data = {
            "id": variant_id,
            "quantity": $('#pdp_quantity_fixed').val(),
            "properties": {
                "preorder": "1"
            }
        }
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            initCart();
           // loadCart();
            openSmallCart();
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}

function quickAddItemToCart(variant_id, preorder) {
    let data = {
        "id": variant_id,
        "quantity": 1
    }

    if(preorder == 1) {
        data = {
            "id": variant_id,
            "quantity": 1,
            "properties": {
                "preorder": "1"
            }
        }
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            initCart();
            openSmallCart();
        },
        error: function (error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
        }
    });
}


$('.variant-id-block input[type="radio"]:first').prop('checked', true);

function addItemToCart(product_id, preorder, multiple_variants) {
    let qty = parseInt($('#pdp_quantity').val());
    let variant_id = 0;

    if(multiple_variants == 1) {
        let options = [];
        let counter = 0;
        $('.multiple-option').each(function(){
            options[counter] = $(this).find('input[type="radio"]:checked').val();
            counter++;
        });

        $('#pdp-multiple-variants-list option').each(function(){
           if(($(this).data('option1') == options[0] && $(this).data('option2') == options[1]) || ($(this).data('option1') == options[0] && $(this).data('option2') == null) || ($(this).data('option1') == options[0] && $(this).data('option2') == '')){
               variant_id = $(this).val();
           }
        });
    }else {
        variant_id = $('.variant-id-block input[type="radio"]:checked').val();
    }

    let data = {
        "id": variant_id,
        "quantity": qty
    }

    if(preorder == 1) {
        data = {
            "id": variant_id,
            "quantity": qty,
            "properties": {
                "preorder": "1"
            }
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                // initCart();
                // loadCart();
                // openSmallCart();
            },
            error: function (error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }

}


function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

